<template>
  <div class="card">
    <div class="card-body py-3" style="padding: 16px 12px;">
      <div class="d-flex justify-content-between align-items-start mb-0">
        <titles style="margin: 0;" text="Cavabdeh şəxs məlumatları" />
        <div class="d-flex align-items-center">
          <div v-if="participantData?.createdBy || participantData?.updatedBy"
            class="record-label-wrapper position-relative" style="margin-right:12px">
            <el-button type="default" size="large" text style="padding: 0px;" :icon="InfoFilled" class="fs-5"></el-button>
            <div class="record-label-tooltip">
              <record-label :created="participantData.createdBy" :updated="participantData.updatedBy"
                style="color: #606266; font-size: 14px;" />
            </div>
          </div>
          <!-- <button type="button" class="btn btn-sm bg-white shadow-none p-0" style="margin: 0;" title="Düzəliş et"
            :disabled="lastStatus === 50" @click="$emit('edit')">
            <i class="fa-regular fa-edit text-muted fs-5"></i>
          </button> -->
          <el-button class="fs-5" type="text" style="padding: 0px;" :icon="Edit" title="Düzəliş et" size="large"
            :disabled="lastStatus === 50" @click="$emit('edit')">
          </el-button>
        </div>
      </div>
      <hr style="margin-top: 0px;" />
      <div class="row" style="color: #606266; font-size: 14px;">
        <div class="col-md-5">
          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Şəxs tipi</div>
            <div class="col-8">
              {{ participantData.personType === 1 ? 'Fiziki şəxs' : participantData.personType === 2 ? 'Hüquqi şəxs' :
                '—' }}
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 font-weight-bold">
              {{ participantData.personType === 1 ? 'FİN' : 'VÖEN' }}
            </div>
            <div class="col-8">
              {{ participantData.personType === 1 ? participantData.pin : participantData.tin }}
            </div>
          </div>
          <div v-if="participantData.personType === 1" class="row mb-2">
            <div class="col-4 font-weight-bold">A.S.A</div>
            <div class="col-8">
              {{ participantData.name }} {{ participantData.surname }} {{ participantData.fatherName }}
            </div>
          </div>
          <div v-if="participantData.personType === 2" class="row mb-2">
            <div class="col-4 font-weight-bold">Ad</div>
            <div class="col-8">{{ participantData.name }}</div>
          </div>
          <div v-if="participantData.personType === 1" class="row mb-2">
            <div class="col-4 font-weight-bold">Cins</div>
            <div class="col-8">
              {{ participantData.gender === 1 ? 'Kişi' : participantData.gender === 2 ? 'Qadın' : '—' }}
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div v-if="participantData.personType === 1" class="row mb-2">
            <div class="col-4 font-weight-bold">Doğum tarixi</div>
            <div class="col-8">{{ DateToString(participantData.birthDate) }}</div>
          </div>
          <div v-if="participantData.personType === 2" class="row mb-2">
            <div class="col-4 font-weight-bold">Nümayəndə</div>
            <div class="col-8">{{ participantData.representative }}</div>
          </div>
          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Telefon</div>
            <div class="col-8">
              {{ participantData.phone }}{{ participantData.additionalPhone ? ', ' + participantData.additionalPhone :
                '' }}
            </div>
          </div>
          <div v-if="participantData.personType === 1" class="row mb-2">
            <div class="col-4 font-weight-bold">İş yeri</div>
            <div class="col-8">{{ participantData.workPlace }}</div>
          </div>
          <div class="row mb-2">
            <div class="col-4 font-weight-bold">Ünvan</div>
            <div class="col-8">{{ participantData.regAddress }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from '@/project/Components/Titles.vue'
import RecordLabel from '@/project/Components/RecordLabel.vue'
import { DateToString } from '@/project/Source/helper'
import { InfoFilled,Edit } from "@element-plus/icons-vue";

export default {
  components: {
    Titles,
    RecordLabel
  },
  props: {
    participantData: {
      type: Object,
      required: true
    },
    lastStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      InfoFilled,
      Edit
    }
  },
  methods: {
    DateToString
  }
}
</script>

<style scoped>
.record-label-wrapper {
  position: relative;
}

.record-label-tooltip {
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  z-index: 1000;
  min-width: 180px;
  opacity: 0;
  transform: translateY(5px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.record-label-wrapper:hover .record-label-tooltip {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.col-8 {
  color: #222222;
}
</style>